// ./components/HeroSection.jsx
import React, { useEffect, useRef, useState } from 'react';
import { motion, useAnimationFrame, useMotionValue } from 'framer-motion';

import GlitchImage from '../assets/images/glitch.png';
import Creative from '../assets/images/creative.jpg';
import Texture from '../assets/images/texture.jpg';
import CustomFont from '../assets/fonts/GRADIOO.ttf';

// DIFFERENT assets for the quote slider
import QuoteTexture from '../assets/images/quote-texture.jpg';
import QuoteFont from '../assets/fonts/AwanNoyeed.otf';

/* ---------------------------------------------
   ANIMATED BACKGROUND COMPONENT
----------------------------------------------*/
const AnimatedBackground = () => {
  const pathVariants = {
    initial: { 
      strokeDashoffset: 800, 
      strokeDasharray: "50 800",
      opacity: 0 
    },
    animate: {
      strokeDashoffset: 0,
      strokeDasharray: "20 800",
      opacity: [0, 0.6, 0.8, 0.4, 0],
    },
  };

  const paths = [
    "M720 450C720 450 742.459 440.315 755.249 425.626C768.039 410.937 778.88 418.741 789.478 401.499C800.076 384.258 817.06 389.269 826.741 380.436C836.423 371.603 851.957 364.826 863.182 356.242C874.408 347.657 877.993 342.678 898.867 333.214C919.741 323.75 923.618 319.88 934.875 310.177C946.133 300.474 960.784 300.837 970.584 287.701C980.384 274.564 993.538 273.334 1004.85 263.087C1016.15 252.84 1026.42 250.801 1038.22 242.1C1050.02 233.399 1065.19 230.418 1074.63 215.721C1084.07 201.024 1085.49 209.128 1112.65 194.884C1139.8 180.64 1132.49 178.205 1146.43 170.636C1160.37 163.066 1168.97 158.613 1181.46 147.982C1193.95 137.35 1191.16 131.382 1217.55 125.645C1243.93 119.907 1234.19 118.899 1254.53 100.846C1274.86 82.7922 1275.12 92.8914 1290.37 76.09C1305.62 59.2886 1313.91 62.1868 1323.19 56.7536C1332.48 51.3204 1347.93 42.8082 1361.95 32.1468C1375.96 21.4855 1374.06 25.168 1397.08 10.1863C1420.09 -4.79534 1421.41 -3.16992 1431.52 -15.0078",
    "M720 450C720 450 741.044 435.759 753.062 410.636C765.079 385.514 770.541 386.148 782.73 370.489C794.918 354.83 799.378 353.188 811.338 332.597C823.298 312.005 825.578 306.419 843.707 295.493C861.837 284.568 856.194 273.248 877.376 256.48C898.558 239.713 887.536 227.843 909.648 214.958C931.759 202.073 925.133 188.092 941.063 177.621C956.994 167.151 952.171 154.663 971.197 135.041C990.222 115.418 990.785 109.375 999.488 96.1291C1008.19 82.8827 1011.4 82.2181 1032.65 61.8861C1053.9 41.5541 1045.74 48.0281 1064.01 19.5798C1082.29 -8.86844 1077.21 -3.89415 1093.7 -19.66C1110.18 -35.4258 1105.91 -46.1146 1127.68 -60.2834C1149.46 -74.4523 1144.37 -72.1024 1154.18 -97.6802C1163.99 -123.258 1165.6 -111.332 1186.21 -135.809C1206.81 -160.285 1203.29 -160.861 1220.31 -177.633C1237.33 -194.406 1236.97 -204.408 1250.42 -214.196",
    "M720 450C720 450 712.336 437.768 690.248 407.156C668.161 376.544 672.543 394.253 665.951 365.784C659.358 337.316 647.903 347.461 636.929 323.197C625.956 298.933 626.831 303.639 609.939 281.01C593.048 258.381 598.7 255.282 582.342 242.504C565.985 229.726 566.053 217.66 559.169 197.116C552.284 176.572 549.348 171.846 529.347 156.529C509.345 141.211 522.053 134.054 505.192 115.653C488.33 97.2527 482.671 82.5627 473.599 70.7833C464.527 59.0039 464.784 50.2169 447 32.0721C429.215 13.9272 436.29 0.858563 423.534 -12.6868C410.777 -26.2322 407.424 -44.0808 394.364 -56.4916C381.303 -68.9024 373.709 -72.6804 365.591 -96.1992C357.473 -119.718 358.364 -111.509 338.222 -136.495C318.08 -161.481 322.797 -149.499 315.32 -181.761C307.843 -214.023 294.563 -202.561 285.795 -223.25C277.026 -243.94 275.199 -244.055 258.602 -263.871",
    "M720 450C720 450 738.983 448.651 790.209 446.852C841.436 445.052 816.31 441.421 861.866 437.296C907.422 433.172 886.273 437.037 930.656 436.651C975.04 436.264 951.399 432.343 1001.57 425.74C1051.73 419.138 1020.72 425.208 1072.85 424.127C1124.97 423.047 1114.39 420.097 1140.02 414.426C1165.65 408.754 1173.1 412.143 1214.55 411.063C1256.01 409.983 1242.78 406.182 1285.56 401.536C1328.35 396.889 1304.66 400.796 1354.41 399.573C1404.16 398.35 1381.34 394.315 1428.34 389.376C1475.35 384.438 1445.96 386.509 1497.93 385.313C1549.9 384.117 1534.63 382.499 1567.23 381.48",
    "M720 450C720 450 696.366 458.841 682.407 472.967C668.448 487.093 673.23 487.471 647.919 492.882C622.608 498.293 636.85 499.899 609.016 512.944C581.182 525.989 596.778 528.494 571.937 533.778C547.095 539.062 551.762 548.656 536.862 556.816C521.962 564.975 515.626 563.279 497.589 575.159C479.552 587.04 484.343 590.435 461.111 598.728C437.879 607.021 442.512 605.226 423.603 618.397C404.694 631.569 402.411 629.541 390.805 641.555C379.2 653.568 369.754 658.175 353.238 663.929C336.722 669.683 330.161 674.689 312.831 684.116C295.5 693.543 288.711 698.815 278.229 704.041C267.747 709.267 258.395 712.506 240.378 726.65C222.361 740.795 230.097 738.379 203.447 745.613C176.797 752.847 193.747 752.523 166.401 767.148C139.056 781.774 151.342 783.641 130.156 791.074C108.97 798.507 116.461 802.688 96.0974 808.817C75.7334 814.946 83.8553 819.505 59.4513 830.576C35.0473 841.648 48.2548 847.874 21.8337 853.886C-4.58739 859.898 10.5966 869.102 -16.396 874.524",
    "M720 450C720 450 695.644 482.465 682.699 506.197C669.755 529.929 671.059 521.996 643.673 556.974C616.286 591.951 625.698 590.8 606.938 615.255C588.178 639.71 592.715 642.351 569.76 665.92C546.805 689.49 557.014 687.498 538.136 722.318C519.258 757.137 520.671 760.818 503.256 774.428C485.841 788.038 491.288 790.063 463.484 831.358C435.681 872.653 437.554 867.001 425.147 885.248C412.74 903.495 411.451 911.175 389.505 934.331C367.559 957.486 375.779 966.276 352.213 990.918C328.647 1015.56 341.908 1008.07 316.804 1047.24C291.699 1086.42 301.938 1060.92 276.644 1100.23C251.349 1139.54 259.792 1138.78 243.151 1153.64",
    "M719.974 450C719.974 450 765.293 459.346 789.305 476.402C813.318 493.459 825.526 487.104 865.093 495.586C904.659 504.068 908.361 510.231 943.918 523.51C979.475 536.789 963.13 535.277 1009.79 547.428C1056.45 559.579 1062.34 555.797 1089.82 568.96C1117.31 582.124 1133.96 582.816 1159.12 592.861C1184.28 602.906 1182.84 603.359 1233.48 614.514C1284.12 625.67 1254.63 632.207 1306.33 644.465C1358.04 656.723 1359.27 656.568 1378.67 670.21C1398.07 683.852 1406.16 676.466 1456.34 692.827C1506.51 709.188 1497.73 708.471 1527.54 715.212"
  ];

  // Page color palette - matching your design
  const colors = [
    "#630000",  // Dark red from your image backgrounds
    "#1B1717",  // Text color
    "#D6590C",  // Orange tone
    "#8B4513",  // Brown tone
    "#696969",  // Darker gray
    "#A0522D",  // Sienna brown
    "#B22222",  // Fire brick red
    "#2F4F4F",  // Dark slate gray
    "#800000",  // Maroon
    "#556B2F"   // Dark olive green
  ];

  return (
    <motion.svg
      viewBox="0 0 1440 900"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      initial={{ opacity: 0, scale: 1.1 }}
      animate={{ opacity: 0.3, scale: 1 }}
      transition={{ 
        duration: 3,
        ease: "easeOut",
        delay: 1.5
      }}
      className="absolute inset-0 w-full h-full"
    >
      {paths.map((path, idx) => (
        <motion.path
          key={`path-first-${idx}`}
          d={path}
          stroke={colors[idx % colors.length]}
          strokeWidth="1.8"
          strokeLinecap="round"
          fill="none"
          variants={pathVariants}
          initial="initial"
          animate="animate"
          transition={{
            duration: 15,
            ease: "easeInOut",
            repeat: Infinity,
            repeatType: "loop",
            delay: 2 + (idx * 0.4),
            repeatDelay: Math.floor(Math.random() * 8 + 4),
          }}
        />
      ))}
      {/* Duplicate paths for more density */}
      {paths.map((path, idx) => (
        <motion.path
          key={`path-second-${idx}`}
          d={path}
          stroke={colors[(idx + 3) % colors.length]}
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="none"
          variants={pathVariants}
          initial="initial"
          animate="animate"
          transition={{
            duration: 18,
            ease: "easeInOut", 
            repeat: Infinity,
            repeatType: "loop",
            delay: 3 + (idx * 0.6),
            repeatDelay: Math.floor(Math.random() * 10 + 5),
          }}
        />
      ))}
    </motion.svg>
  );
};

/* ---------------------------------------------
   PERFECT INFINITE MARQUEE - NEVER STOPS, NEVER REVERSES
----------------------------------------------*/
const PerfectMarquee = ({ children, speed = 50 }) => {
  const x = useMotionValue(0);
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);

  // Get container width
  useEffect(() => {
    if (!containerRef.current) return;
    
    const updateWidth = () => {
      const rect = containerRef.current.getBoundingClientRect();
      setContainerWidth(rect.width);
    };
    
    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  // PERFECT INFINITE ANIMATION - SUPPORTS BOTH DIRECTIONS
  useAnimationFrame((time, delta) => {
    if (containerWidth === 0) return;
    
    // Move at constant speed (pixels per second)
    const pixelsPerSecond = Math.abs(speed);
    const moveAmount = (pixelsPerSecond * delta) / 1000;
    
    const currentX = x.get();
    let newX;
    
    if (speed > 0) {
      // Positive speed: move left (text appears to go right to left)
      newX = currentX - moveAmount;
      if (Math.abs(newX) >= containerWidth) {
        newX = 0;
      }
    } else {
      // Negative speed: move right (text appears to go left to right)
      newX = currentX + moveAmount;
      if (newX >= 0) {
        newX = -containerWidth;
      }
    }
    
    x.set(newX);
  });

  return (
    <div className="overflow-hidden w-full">
      <motion.div
        ref={containerRef}
        style={{ x }}
        className="flex whitespace-nowrap will-change-transform"
      >
        {/* Render enough copies to ensure seamless loop */}
        {Array.from({ length: 10 }, (_, i) => (
          <div key={i} className="flex-shrink-0">
            {children}
          </div>
        ))}
      </motion.div>
    </div>
  );
};

/* ---------------------------------------------
   HERO SECTION
----------------------------------------------*/
const HeroSection = () => {
  // Font faces for BOTH custom fonts
  const fontStyles = `
    @font-face {
      font-family: 'CustomGrad';
      src: url(${CustomFont}) format('truetype');
      font-weight: 700;
      font-style: normal;
      font-display: swap;
    }
    @font-face {
      font-family: 'QuoteFont';
      src: url(${QuoteFont}) format('truetype');
      font-weight: 400;
      font-style: normal;
      font-display: swap;
    }
  `;

  // HERO TITLE styles (using original texture & font)
  const heroTexture = {
    backgroundImage: `url(${Texture})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    color: 'transparent',
    WebkitTextFillColor: 'transparent',
    fontFamily: 'CustomGrad, sans-serif',
  };
  const heroTextureLG = { ...heroTexture, fontSize: '1.4em' };

  // QUOTE SLIDER styles (using DIFFERENT texture & font)
  const quoteStyles = {
    backgroundImage: `url(${QuoteTexture})`,
    backgroundSize: '300% 300%',
    backgroundPosition: 'center',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    color: 'transparent',
    WebkitTextFillColor: 'transparent',
    fontFamily: 'QuoteFont, serif',
    animation: 'quoteTextureFlow 25s linear infinite',
  };

  // Animation refs
  const firstRowRef = useRef(null);
  const secondRowRef = useRef(null);
  const paragraphRef = useRef(null);

  // Smooth entrance animations with staggered timing - SLOWER WITH MORE DELAYS
  useEffect(() => {
    const elements = [
      { ref: firstRowRef.current, delay: 2000 },    // 2s delay
      { ref: secondRowRef.current, delay: 2600 },   // 2.6s delay
      { ref: paragraphRef.current, delay: 3200 }   // 2s delay
    ].filter(item => item.ref);

    const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    
    if (prefersReducedMotion) {
      elements.forEach(item => item.ref?.classList.add('animate-in'));
      return;
    }

    // Trigger animations on page load
    const triggerAnimations = () => {
      elements.forEach(({ ref, delay }) => {
        setTimeout(() => {
          ref?.classList.add('animate-in');
        }, delay);
      });
    };

    // Trigger immediately on mount (page load/refresh)
    triggerAnimations();

    // Also trigger when coming back to section (intersection observer)
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Reset and retrigger animations when coming back to section
            const element = entry.target;
            element.classList.remove('animate-in');
            
            // Longer delay to ensure proper reset
            setTimeout(() => {
              element.classList.add('animate-in');
            }, 100);
          }
        });
      },
      { threshold: 0.3 }
    );

    elements.forEach(({ ref }) => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center bg-[#EDEBDD] overflow-hidden">
      {/* ANIMATED BACKGROUND */}
      <AnimatedBackground />
      
      {/* ALL STYLES */}
      <style>{fontStyles}</style>
      <style>{`
        /* SMOOTH ENTRANCE ANIMATIONS */
        .hero-element {
          opacity: 0;
          transform: translate3d(0, 0, 0) scale(0.92);
          filter: blur(12px);
          will-change: transform, opacity, filter;
          transition: 
            transform 2s cubic-bezier(0.16, 1, 0.3, 1),
            opacity 2s cubic-bezier(0.16, 1, 0.3, 1),
            filter 2s cubic-bezier(0.16, 1, 0.3, 1);
        }
        
        /* Direction-specific starting positions - MORE DRAMATIC */
        .slide-from-left { 
          transform: translate3d(-200px, 0, 0) scale(0.85) rotateY(-15deg);
          animation-delay: 0.6s;
        }
        .slide-from-right { 
          transform: translate3d(200px, 0, 0) scale(0.85) rotateY(15deg);
          animation-delay: 1.2s;
        }
        .slide-from-down { 
          transform: translate3d(0, 100px, 0) scale(0.85) rotateX(15deg);
          animation-delay: 1.8s;
        }
        
        /* Final animated state - SMOOTH SETTLE */
        .animate-in { 
          opacity: 1; 
          transform: translate3d(0, 0, 0) scale(1) rotateY(0deg) rotateX(0deg); 
          filter: blur(0px);
        }
        
        /* Staggered children animations with MORE DELAY */
        .hero-element > *:nth-child(1) { 
          transition-delay: inherit; 
        }
        .hero-element > *:nth-child(2) { 
          transition-delay: calc(var(--base-delay, 0.6s) + 0.4s); 
        }
        .hero-element > *:nth-child(3) { 
          transition-delay: calc(var(--base-delay, 0.6s) + 0.8s); 
        }
        
        /* Enhanced spring animation timing */
        .hero-element.slide-from-left.animate-in {
          --base-delay: 0.6s;
        }
        .hero-element.slide-from-right.animate-in {
          --base-delay: 1.2s;
        }
        .hero-element.slide-from-down.animate-in {
          --base-delay: 1.8s;
        }, 0.3, 1);
        }
        
        /* Direction-specific starting positions */
        .slide-from-left { 
          transform: translate3d(-120px, 0, 0) scale(0.95);
          animation-delay: 0.3s;
        }
        .slide-from-right { 
          transform: translate3d(120px, 0, 0) scale(0.95);
          animation-delay: 0.7s;
        }
        .slide-from-down { 
          transform: translate3d(0, 60px, 0) scale(0.95);
          animation-delay: 1.1s;
        }
        
        /* Final animated state */
        .animate-in { 
          opacity: 1; 
          transform: translate3d(0, 0, 0) scale(1); 
          filter: blur(0);
        }
        
        /* Individual element stagger delays within each container */
        .hero-element > *:nth-child(1) { transition-delay: inherit; }
        .hero-element > *:nth-child(2) { transition-delay: calc(var(--base-delay, 0.3s) + 0.15s); }
        .hero-element > *:nth-child(3) { transition-delay: calc(var(--base-delay, 0.3s) + 0.3s); }
        
        /* Smooth spring animation on load */
        .hero-element.slide-from-left.animate-in {
          --base-delay: 0.3s;
        }
        .hero-element.slide-from-right.animate-in {
          --base-delay: 0.7s;
        }
        .hero-element.slide-from-down.animate-in {
          --base-delay: 1.1s;
        }
        
        /* Quote Texture Animation */
        @keyframes quoteTextureFlow {
          0% { background-position: 0% 50%; }
          25% { background-position: 100% 25%; }
          50% { background-position: 50% 100%; }
          75% { background-position: 25% 0%; }
          100% { background-position: 0% 50%; }
        }
        
        /* Disable animations for reduced motion */
        @media (prefers-reduced-motion: reduce) {
          .hero-element, .animate-in { 
            transition: none !important; 
            filter: none !important; 
            transform: none !important; 
            opacity: 1 !important; 
          }
          * { animation: none !important; }
        }
      `}</style>

      {/* HERO CONTENT - CENTERED MORE IN MIDDLE */}
      <div className="relative z-10 max-w-5xl w-full px-6 text-center text-[#1B1717] mt-16 mb-auto">
        <h1 className="font-extrabold leading-[1.05] tracking-tight text-4xl sm:text-5xl md:text-7xl flex flex-col items-center gap-3">
          {/* Row 1 — SLIDES FROM LEFT with staggered children */}
          <div
            ref={firstRowRef}
            className="hero-element slide-from-left flex items-center gap-4 flex-wrap justify-center"
          >
            <span style={heroTexture}>Hello</span>
            <span className="inline-flex items-center rounded-full overflow-hidden w-[100px] h-[56px] sm:w-[120px] sm:h-[64px] bg-[#630000]">
              <img src={GlitchImage} alt="Adam" className="object-cover w-full h-full" />
            </span>
            <span style={heroTextureLG}>I'm Adam</span>
          </div>

          {/* Row 2 — SLIDES FROM RIGHT with staggered children */}
          <div
            ref={secondRowRef}
            className="hero-element slide-from-right flex items-center gap-4 flex-wrap justify-center"
          >
            <span style={heroTextureLG}>I build</span>
            <span className="inline-flex items-center rounded-full overflow-hidden w-[110px] h-[60px] sm:w-[130px] sm:h-[70px]">
              <img src={Creative} alt="Creative" className="object-cover w-full h-full" />
            </span>
            <span style={heroTextureLG}>experiences</span>
          </div>
        </h1>

        {/* Paragraph — SLIDES FROM DOWN */}
          <p
            ref={paragraphRef}
            className="hero-element slide-from-down mt-6 mx-auto max-w-3xl text-base sm:text-lg md:text-xl leading-relaxed"
          >
            
            {`Full-stack developer focused on fast, accessible interfaces and solid backends. I craft modern web apps with React/Next.js, Node/Express, TypeScript, and clean UI systems.`}
          </p>
        </div>

      {/* PERFECT DUAL INFINITE MARQUEE - AT BOTTOM OF SECTION */}
      <div className="relative z-10 w-full mt-auto mb-8 select-none space-y-4">
        {/* TOP LINE - Moving Right to Left */}
        <PerfectMarquee speed={100}>
          <div 
            className="px-12 text-3xl md:text-5xl lg:text-6xl font-bold uppercase tracking-tight whitespace-nowrap"
            style={quoteStyles}
          >
            You were born original — don't die a copy
          </div>
        </PerfectMarquee>
        
        {/* BOTTOM LINE - Moving Left to Right */}
        <PerfectMarquee speed={-100}>
          <div 
            className="px-12 text-3xl md:text-5xl lg:text-6xl font-bold uppercase tracking-tight whitespace-nowrap"
            style={quoteStyles}
          >
            You were born original — don't die a copy
          </div>
        </PerfectMarquee>
      </div>
    </section>
  );
};

export default HeroSection;